import React, { Component } from 'react'

export default class AlertTwo extends Component {

    CloseFx = () => {

        this.props.closeMe()
    
    }

    render() {

        return (
            
            <div className='NightWrapper2' onClick = {this.CloseFx}>

                <p id='DeniedTwo'>{this.props.alert}</p>

            </div>
        )

    }

}



// WEBPACK FOOTER //
// ./src/components/etc/AlertTwo.js